import React from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

/*
 * Custom icons not found in Material UI icons.
 */

export function PinIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M14 3.66668V8.25001C14 9.27668 14.37 10.23 15 11H9C9.65 10.2117 10 9.25834 10 8.25001V3.66668H14ZM17 1.83334H7C6.45 1.83334 6 2.24584 6 2.75001C6 3.25418 6.45 3.66668 7 3.66668H8V8.25001C8 9.77168 6.66 11 5 11V12.8333H10.97V19.25L11.97 20.1667L12.97 19.25V12.8333H19V11C17.34 11 16 9.77168 16 8.25001V3.66668H17C17.55 3.66668 18 3.25418 18 2.75001C18 2.24584 17.55 1.83334 17 1.83334Z" />
    </SvgIcon>
  );
}
